import { useRef, useState, useEffect } from "react";
import type * as type from "@vTypes";
import CustomModal from "@/components/modal/CustomModal";

function ConfTableAddRow({
  setAddNewShifts,
  addShift,

  currentShiftManage,
  saveShiftManage,

  shiftIdFlatMap,
}: {
  setAddNewShifts: (value: boolean) => void;
  addShift: (value: type.AddShift) => void;

  currentShiftManage: type.ShiftManageObject[];
  saveShiftManage: (value: type.ShiftManageObject[]) => void;

  shiftIdFlatMap: string[];
}) {
  const [isTypeListOpend, setIsTypeListOpend] = useState<boolean>(false);
  const [isSlotListOpend, setIsSlotListOpend] = useState<boolean>(false);

  const [shiftId, setShiftId] = useState<string>("");
  const [color, setColor] = useState<string>("#000000");
  const [shiftName, setShiftName] = useState<string>("");
  const [startTime, setStartTime] = useState<string>("00:00");
  const [endTime, setEndTime] = useState<string>("23:59");
  const [workType, setWorkType] = useState<string>("근무");
  const [showInPreference, setShowInPreference] = useState<boolean>(false);

  const rowRef = useRef<HTMLDivElement | null>(null);

  const [slotIndex, setSlotIndex] = useState<number>(0);
  const [copyCurrentShiftManage, setCopyCurrentShiftManage] =
    useState<type.ShiftManageObject[]>(currentShiftManage);
  // const [slotText, setSlotText] = useState<string>("-");

  const [isDuplicateShiftId, setIsDuplicateShiftId] = useState<boolean>(false);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("근무코드를 입력해주세요");

  const workArray = ["근무", "공가", "휴가"];
  const slotArray = ["-", "데이", "이브닝", "나이트", "고정근무"];

  const shiftInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    shiftInputRef.current?.focus();
  }, []);

  const addNewShifts = () => {
    let shift_gb: string | null = null;
    if (workType === "근무") {
      if (slotIndex === 4) {
        shift_gb = "고정";
      } else if (slotIndex > 0) {
        shift_gb = slotArray[slotIndex];
      }
    }

    const newShifts = {
      shift_id: shiftId,
      name: shiftName,
      color: color,
      start_time: workType !== "근무" ? null : startTime,
      end_time: workType !== "근무" ? null : endTime,
      type: workType,
      shift_gb,
      show_in_preference: showInPreference,
      off_swap_target: false,
    };
    addShift(newShifts);
  };

  function updateShiftSlot(shifts: string, slot: number) {
    setCopyCurrentShiftManage((prev) =>
      prev.map((item) => {
        // 1단계: 기존에 있는 shifts 제거
        const newCodes = item.codes.filter((code) => code !== shifts);
        // 2단계: slot이 일치하면 다시 추가
        if (item.shift_slot === slot && slot > 0) {
          newCodes.push(shifts);
        }
        return { ...item, codes: newCodes };
      })
    );
  }

  return (
    <div
      ref={rowRef}
      className="conf_shiftCode__gridTemplate conf_shiftCode__row editMode"
    >
      {/* 드래그 버튼 */}
      <div className="conf_shiftCode__td">
        <div className="conf_button__handler">
          <span className="img_iconHandler"></span>
        </div>
      </div>

      {/* 근무코드 */}
      <div className="conf_shiftCode__td">
        <div
          className={`conf_shiftDisplay ${isDuplicateShiftId ? "conf_shiftDisplay--duplicate" : ""}`}
          style={{ backgroundColor: color }}
        >
          <input
            ref={shiftInputRef}
            type="text"
            className="conf_shiftCode"
            value={shiftId}
            onChange={(e) => {
              const changeValue = e.currentTarget.value;
              setIsDuplicateShiftId(shiftIdFlatMap.includes(changeValue));
              setShiftId(changeValue);
            }}
          />
        </div>
      </div>

      {/* 이름 */}
      <div className="conf_shiftCode__td">
        <input
          type="text"
          className="conf_shiftName editMode"
          value={shiftName}
          onInput={(e) => {
            const changeValue = e.currentTarget.value;
            setShiftName(changeValue);
          }}
        />
      </div>

      {/* 구분 */}
      <div className="conf_shiftCode__td">
        <div className="conf_selectType_wrap">
          <button
            type="button"
            className="conf_selectType conf_selectType--button"
            disabled={workType !== "근무"}
            style={workType !== "근무" ? { cursor: "not-allowed", opacity: 0.5 } : {}}
            onClick={() => {
              setIsSlotListOpend((prev) => !prev);
            }}
          >
            {slotArray[slotIndex]}
          </button>
          {isSlotListOpend && (
            <div className="conf_selectType_list">
              {slotArray.map((type, index) => {
                const isSelected = index === slotIndex;
                return (
                  <button
                    key={index}
                    type="button"
                    className={`conf_selectType_item ${isSelected && "selected"}`}
                    onClick={() => {
                      // updateShiftSlot(data.shift_id, index)
                      setSlotIndex(index);
                      updateShiftSlot(shiftId, index === 4 ? 0 : index);
                      setIsSlotListOpend(false);
                      if (index !== 0) {
                        setShowInPreference(false);
                      }
                    }}
                  >
                    {type}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* 근무시간: 타입 근무일 때만 time input, 그 외(공가/휴가)는 '-' + null */}
      <div className="flex justify-center items-center">
        <div className="grid grid-cols-[1fr_auto_1fr] gap-x-1 flex-1 max-w-[220px] items-center">
          {workType !== "근무" ? (
            <div className="text-center flex items-center justify-center">-</div>
          ) : (
            <input
              type="time"
              className="conf_shift_time edit"
              value={startTime}
              onChange={(e) => setStartTime(e.currentTarget.value)}
            />
          )}
          ~
          {workType !== "근무" ? (
            <div className="text-center flex items-center justify-center">-</div>
          ) : (
            <input
              type="time"
              className="conf_shift_time edit"
              value={endTime}
              onChange={(e) => setEndTime(e.currentTarget.value)}
            />
          )}
        </div>
      </div>

      {/* 타입 */}
      <div className="conf_shiftCode__td">
        <div className="conf_selectType_wrap">
          <button
            type="button"
            className="conf_selectType conf_selectType--button"
            onClick={() => {
              setIsTypeListOpend((prev) => !prev);
            }}
          >
            {workType}
          </button>
          {isTypeListOpend && (
            <div className="conf_selectType_list">
              {workArray.map((type, index) => {
                const isSelected = workType === type;
                return (
                  <button
                    key={index}
                    type="button"
                    className={`conf_selectType_item ${isSelected && "selected"}`}
                    onClick={() => {
                      setWorkType(type);
                      setIsTypeListOpend(false);
                      if (type !== "근무") {
                        setSlotIndex(0);
                        updateShiftSlot(shiftId, 0);
                      } else if (startTime === "" || endTime === "") {
                        setStartTime("00:00");
                        setEndTime("23:59");
                      }
                    }}
                  >
                    {type}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* 원티드 반영: 구분(shift_gb) null인 것만 on/off, 그 외 disabled */}
      <div className="conf_shiftCode__td"></div>

      <div className="conf_shiftCode__td">
        {(() => {
          const 원티드반영비활성 = Boolean(
            slotIndex !== 0 || workType !== "근무"
          );
          return (
            <label
              className={`conf_slideSwitch ${원티드반영비활성 ? "conf_slideSwitch--disabled" : ""}`}
              title={
                원티드반영비활성
                  ? "구분이 '-'이고 타입이 '근무'인 경우만 원티드 반영 on/off 가능합니다"
                  : undefined
              }
            >
              <input
                type="checkbox"
                checked={showInPreference}
                disabled={원티드반영비활성}
                onChange={(e) => {
                  if (원티드반영비활성) return;
                  setShowInPreference(e.currentTarget.checked);
                }}
              />
              <span className="conf_switchHandler"></span>
            </label>
          );
        })()}
      </div>

      {/* 색상 */}
      <div className="conf_shiftCode__td">
        <label
          className="conf_shiftColor__label edit"
          style={{ backgroundColor: color }}
        >
          <input
            type="color"
            value={color}
            onChange={(e) => {
              const changeValue = e.currentTarget.value;
              setColor(changeValue);
            }}
          />
        </label>
      </div>

      {/* 수정버튼 */}
      <div className="conf_shiftCode__td">
        <button
          type="button"
          className={`conf_mode_saveButton ${isDuplicateShiftId ? "errorShiftId hoverMessageWrap" : ""}`}
          disabled={isDuplicateShiftId}
          onClick={() => {
            if (!shiftId || shiftId.trim() === "") {
              setAlertMessage("근무코드를 입력해주세요");
              setIsAlertModalOpen(true);
              return;
            }
            if (!shiftName || shiftName.trim() === "") {
              setAlertMessage("이름을 입력해주세요");
              setIsAlertModalOpen(true);
              return;
            }
            addNewShifts();
            saveShiftManage(copyCurrentShiftManage);
            setAddNewShifts(false);
          }}
        >
          저장
          {isDuplicateShiftId && (
            <span className="hoverMessage">동일한 근무코드가 존재합니다.</span>
          )}
        </button>
      </div>

      {/* 취소버튼 */}
      <div className="conf_shiftCode__td">
        <button
          type="button"
          onClick={() => {
            setAddNewShifts(false);
          }}
        >
          {" "}
          취소{" "}
        </button>
      </div>
      <CustomModal.Alert
        isOpen={isAlertModalOpen}
        onClose={() => setIsAlertModalOpen(false)}
        title={alertMessage}
      />
    </div>
  );
}

export default ConfTableAddRow;
